import { Box, Button } from "@mui/material";
import React, { useRef, useState } from "react";
import ReactCrop, { centerCrop, makeAspectCrop } from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import StyledImageCropper from "./StyledImageCropper";

const ImageCropper = ({
  src,
  aspectRatio = 1,
  fixedCropWidth = "85",
  onCancel,
  onCropComplete,
}) => {
  const [crop, setCrop] = useState();
  const imageRef = useRef(null);

  const onImageLoad = (e) => {
    const { width, height } = e.currentTarget;
    const crop = makeAspectCrop(
      {
        unit: "px",
        width: fixedCropWidth,
      },
      aspectRatio,
      width,
      height
    );
    const centeredCrop = centerCrop(crop, width, height);
    setCrop(centeredCrop);
  };

  const handleCrop = () => {
    if (!imageRef.current || !crop?.width || !crop?.height) {
      console.error("Crop data is invalid");
      return;
    }

    const image = imageRef.current;
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error("Canvas is empty"));
          return;
        }
        const file = new File([blob], "cropped-image.jpg", { type: "image/jpeg" });

        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          resolve({ base64: reader.result, file });
        };
        reader.onerror = reject;
      }, "image/jpeg");
    });
  };

  return (
    <StyledImageCropper>
      <Box className='cropper-wrap'>
        <ReactCrop
          crop={crop}
          keepSelection
          aspect={aspectRatio}
          minWidth={fixedCropWidth}
          onChange={(pixelCrop) => setCrop(pixelCrop)}
        >
          <img
            ref={imageRef}
            src={src}
            alt=''
            style={{ minHeight: "50vh", maxHeight: "50vh" }}
            onLoad={onImageLoad}
          />
        </ReactCrop>
        <Box className='cropper-btn'>
          <Button
            className='crop-btn'
            onClick={async () => {
              try {
                const { base64, file } = await handleCrop();
                onCropComplete({ base64, file });
              } catch (error) {
                console.error("Cropping failed:", error);
              }
            }}
          >
            Crop
          </Button>
          <Button className='cancel-btn' onClick={onCancel}>
            Cancel
          </Button>
        </Box>
      </Box>
    </StyledImageCropper>
  );
};

export default ImageCropper;
